import { LodgingRequestExportExcelState, LodgingRequestExportExcelActionTypes, LODGING_REQUEST_EXPORT_EXCEL_REQUEST, LODGING_REQUEST_EXPORT_EXCEL_SUCCESS, LODGING_REQUEST_EXPORT_EXCEL_FAILURE } from "store/reducers/lodgingRequest/exportExcel/types";

const defaultState: LodgingRequestExportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function exportExcel(state = defaultState, action: LodgingRequestExportExcelActionTypes): LodgingRequestExportExcelState {
  switch (action.type) {
    case LODGING_REQUEST_EXPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LODGING_REQUEST_EXPORT_EXCEL_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LODGING_REQUEST_EXPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};